import React, { useState, useEffect } from 'react';
import { Box , Typography, Table, TableBody, TableContainer, Stack,Chip, TableHead, TableRow, Paper, CircularProgress } from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

import Nuevatarea from './Nuevatarea';
import Deletetarea from './Deletetarea';
import Editartarea from './Editartarea'; 
import Celda from './Celda';  
import BASE_URL from '../../config';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {backgroundColor: grey[100]}
}));

export default function TareasPage() {
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTareas = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/tareas/`);
      if (!res.ok) throw new Error("Error en la respuesta del servidor");
      const data = await res.json();
      const normalizedData = data.map(item => ({
        ...item,
        equipo: Array.isArray(item.equipo) ? item.equipo : [],
        tarea_nombres: Array.isArray(item.tarea_nombres) ? item.tarea_nombres : [],
      }));
      setTareas(normalizedData);
    } catch (e) {
      console.error("Error cargando tareas:", e);
      setTareas([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { 
    fetchTareas(); 
  }, []);

  return (
    <Box sx={{ p: 0, m: 0 }}>
      <Box sx={{display:'flex',flexDirection:{xs:'column',sm:'row'},gap:2,alignItems:{xs:'flex-start',sm:'center'},justifyContent:'space-between'}}>
        <Box sx={{mr:2}}>
          <Typography variant='h6'>Administración de Tareas</Typography>
          <Typography variant='body1' color='textSecondary'>Gestiona las tareas del personal</Typography>
        </Box>
          <Box sx={{width:{xs:'100%',sm:'auto'}}}>
            <Nuevatarea refresh={fetchTareas}/>
          </Box>
      </Box>

        <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start',flexDirection: { xs: 'column', md: 'row' }}}>

          <TableContainer component={Paper}  sx={{ flex: 3, mt:3, maxHeight: 590,
              borderRadius: 3,
              width:'100%',
              border:`1px solid ${grey[400]}`,
              overflowX: 'auto' , '&::-webkit-scrollbar': {
              display: 'none',
              },
              // Ocultar para Firefox
              scrollbarWidth: 'none',
              // Ocultar para Internet Explorer y Edge antiguo
              msOverflowStyle: 'none',}}>

            <Table  sx={{maxWidth: '100%', }} stickyHeader aria-label="customized table" >
            <TableHead sx={{ bgcolor: grey[100] }}>
              <TableRow >
                <StyledTableCell sx={{fontWeight:'bold'}}>Tarea</StyledTableCell>
                <StyledTableCell sx={{fontWeight:'bold',maxWidth:100}}>Equipo</StyledTableCell>
                <StyledTableCell sx={{fontWeight:'bold'}} align='right'>Acciones</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={3} sx={{ py: 10 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <CircularProgress size={40} sx={{ color: grey[500] }} />
                      <Typography sx={{ mt: 2, color: grey[600] }}>Cargando tareas...</Typography>
                    </Box>
                  </TableCell>
                </TableRow>
              ) : tareas.map((asignacion) =>(
                <TableRow  
                    hover 
                    key={asignacion.id} 
                    sx={{ 
                    '&:last-child td, &:last-child th': { border: 0 },
                    height: '60px' // Forzamos una altura consistente para todas las filas
                  }}
                >
                  {/* NOMBRE*/}
                  <TableCell variant="body">{asignacion.nombre}</TableCell>

                  {/* EQUIPO*/}
                  <TableCell variant='body'>
                    <Celda permisosArray={asignacion.equipo} limite={2}></Celda>
                  </TableCell>

                  {/* ACCIONES*/}
                  <TableCell align="center" sx={{width:100}}>
                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1 }}>
                        <Editartarea tareas={asignacion} refresh={fetchTareas} />
                        <Deletetarea tarea={asignacion} refresh={fetchTareas} />
                    </Box>
                  </TableCell>
                </TableRow>
              )
              )}
            </TableBody>
            </Table>
          </TableContainer>

        </Box>

    </Box>
  );
}